import { Button, FeedbackState } from '@webmotors/eleanor-ui';
import { MY_ADS_PAGE, MY_ADS_TEST_IDS } from '../../utils';

type TErrorStateConfig = {
	onRetry: () => void;
};

const ErrorState = ({ onRetry }: TErrorStateConfig) => (
	<FeedbackState size="large" className="mx-auto" data-testid={MY_ADS_TEST_IDS.ERROR_STATE}>
		<FeedbackState.Icon type="negative" />
		<FeedbackState.Title>{MY_ADS_PAGE.ERROR_STATE.TITLE}</FeedbackState.Title>
		<FeedbackState.Description>{MY_ADS_PAGE.ERROR_STATE.DESCRIPTION}</FeedbackState.Description>
		<FeedbackState.Actions>
			<Button
				variant="secondary"
				size="medium"
				onClick={onRetry}
				data-testid={MY_ADS_TEST_IDS.ERROR_STATE_RETRY_BUTTON}
			>
				{MY_ADS_PAGE.ERROR_STATE.RETRY_BUTTON}
			</Button>
		</FeedbackState.Actions>
	</FeedbackState>
);

ErrorState.displayName = 'ErrorState';

export { ErrorState };
export type { TErrorStateConfig };
